export default "__VITE_ASSET__CIaUO8dP__"